import { BASE_COLORS } from '@lib/ui/theme';

import { GoogleMap } from '../../map';
import { MapBaseOverlay } from '../base-overlay';
import { IPolygonEvents } from './polygon-events';
import { IPolygonOptions } from './polygon-options';

const DEFAULT_OPTIONS: IPolygonOptions = {
  strokeOpacity: 0,
  fillColor: BASE_COLORS['primary-400'],
  strokeColor: BASE_COLORS['accent-400'],
  hoverFillCover: BASE_COLORS['accent-400'],
  paths: [],
};

export class Polygon<
  TEvents extends IPolygonEvents = IPolygonEvents,
> extends MapBaseOverlay<TEvents> {
  private readonly _googleEventListeners: google.maps.MapsEventListener[] = [];
  private _polygon: google.maps.Polygon;

  public constructor(options?: IPolygonOptions) {
    super(options);

    options = { ...DEFAULT_OPTIONS, ...options };
    // make polygon object
    this._polygon = this._makeGoogleMapPolygon(options);
  }

  public setFillColor(color: string): void {
    this._polygon.setOptions({ fillColor: color });
  }

  protected onAdd(map: GoogleMap): void {
    this._polygon.setMap(map.mapInstance);
    this._addEventListeners();
  }

  protected onRemove(): void {
    this._polygon.setMap(null);
    this._destroyEventListeners();
  }

  protected draw(): void {}

  private _click(event: MouseEvent): void {
    this.fire('click', event, true);
  }

  private _mouseOver(): void {
    this.fire('mouseover');
  }

  private _mouseOut(): void {
    this.fire('mouseout');
  }

  private _makeGoogleMapPolygon(options: IPolygonOptions): google.maps.Polygon {
    return new google.maps.Polygon({
      fillColor: options.fillColor,
      strokeOpacity: options.strokeOpacity,
      strokeColor: options.strokeColor,
      paths: options.paths,
    });
  }

  private _addEventListeners(): void {
    this._googleEventListeners.push(
      this._polygon.addListener('mouseover', this._mouseOver.bind(this)),
      this._polygon.addListener('mouseout', this._mouseOut.bind(this)),
      this._polygon.addListener('click', this._click.bind(this)),
    );
  }

  private _destroyEventListeners(): void {
    this._googleEventListeners.forEach((event) => event.remove());
    this._googleEventListeners.length = 0;
  }
}
